export const linkedInShareUrl = (
  url,
  width = 500,
  height = 500,
  left = 100,
  top = 80,
  resizable = 1,
  replace = false
) => {
  window.open(
    `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    '_blank',
    `width=${width},height=${height},toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=${
      resizable ? 1 : 0
    },left=${left},top=${top}`,
    replace
  );
};
